import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 153-square-checkbox
 * @see {GlyphIcon}
 */
const SquareCheckboxIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M24,15.75049,27,12.426V23.5A3.50424,3.50424,0,0,1,23.5,27H8.5A3.50424,3.50424,0,0,1,5,23.5V8.5A3.50424,3.50424,0,0,1,8.5,5h15a3.47066,3.47066,0,0,1,1.40424.29907,2.45024,2.45024,0,0,0-.24311.17456L21.78619,8H8.5a.50641.50641,0,0,0-.5.5v15a.50641.50641,0,0,0,.5.5h15a.50641.50641,0,0,0,.5-.5Zm3.66412-7.753-.99933-.99927a.5.5,0,0,0-.68359-.0221L15.33331,16.33325l-3.63842-1.81909a.5.5,0,0,0-.61408.13477l-.8092,1.01147a.50012.50012,0,0,0,.027.65576l4.62433,4.89636a1,1,0,0,0,1.46942-.01672L27.68176,8.686A.5.5,0,0,0,27.66412,7.99744Z";
	}
}

export default SquareCheckboxIcon;